import React from 'react';
import {
  Heading,
  Flex,
  FormikField,
  rem,
  Text,
  TextInput,
} from '@feast-it/pesto';

const BusinessName = () => {
  return (
    <Flex flexDirection="column" alignItems="center" justifyContent="center">
      <Heading
        textAlign="center"
        mb={{ _: 2, m: 4 }}
        color="blueDark"
        fontSize={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
        lineHeight={{ _: 'headingExtraLargeMobile', m: 'headingLargeMobile' }}
        fontWeight={500}
      >
        What’s the name of your business?
      </Heading>

      <Text
        color="blueDark"
        textAlign="center"
        mb={4}
        fontFamily="body"
        fontSize={{ _: 'body', m: 'headingMediumMobile' }}
        lineHeight={{ _: 'body', m: 'headingMediumMobile' }}
      >
        This will be the name that appears on your profile.
      </Text>

      <FormikField
        as={TextInput}
        width={{ _: '100%', l: rem(839) }}
        size="xxl"
        mt={rem(52)}
        name="supplier.name"
        placeholder="Your business name"
        variant="rounded"
        color="blueDark"
        fontFamily="body"
      />
    </Flex>
  );
};

export default BusinessName;
